import {
  CssBaseline,
  InitColorSchemeScript,
  ThemeProvider as MuiThemeProvider,
} from "@mui/material"
import { Globals, useReducedMotion } from "@react-spring/web"
import React, { PropsWithChildren, useEffect, useMemo } from "react"

import { ThemeSideEffects } from "./components/ThemeSideEffects"
import { theme } from "./theme"

export function ThemeProvider({ children }: PropsWithChildren) {
  const browserPreference = useReducedMotion()

  const skipAnimation = useMemo(() => {
    if (browserPreference) {
      return browserPreference
    } else {
      return false // isMobile
    }
  }, [browserPreference])

  useEffect(() => {
    Globals.assign({ skipAnimation })
  }, [skipAnimation])

  return (
    <MuiThemeProvider
      theme={theme}
      defaultMode="system"
      disableTransitionOnChange
      modeStorageKey={Math.random().toString()}
    >
      <CssBaseline enableColorScheme />
      <InitColorSchemeScript attribute="class" />
      {children}
      <ThemeSideEffects />
    </MuiThemeProvider>
  )
}
